import { render, staticRenderFns } from "./AppUserSitePrefOptions.vue?vue&type=template&id=64b81f4e&scoped=true&"
import script from "./AppUserSitePrefOptions.vue?vue&type=script&lang=js&"
export * from "./AppUserSitePrefOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b81f4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBtn,VSwitch,VTreeview})
